import React from "react";
import "./styles.scss";
import { Link } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ProfilePicture from "./../ProfilePicture";
import ImageUploader from "../../../shared/ImageUploader";
import { createMedium } from "../../../../api/media";
import { updateCurrentUserRedux } from "../../../../api/helper";

export default ({ className, user, disabled, onClick, editProfilePicture }) =>
  disabled ? (
    <span className={`user-square-tag ${className}`} onClick={onClick}>
      {editProfilePicture ? (
        <ImageUploader
          onSubmit={s3_object_key =>
            createMedium({
              media: {
                type: "ProfilePicture",
                s3_object_key
              }
            }).then(updateCurrentUserRedux)
          }
          className="edit_picture_overlay mr-3"
        >
          <ProfilePicture user={user} />
        </ImageUploader>
      ) : (
        <ProfilePicture user={user} />
      )}
      <p className="my-3">{user.username}</p>
    </span>
  ) : (
      <Link className={`user-square-tag ${className}`} to={`/${user.slug}`}>
          <ProfilePicture user={user} />
          <OverlayTrigger
              placement="top"
              overlay={<Tooltip>{user.username}</Tooltip>}
          >
            <p style={{ cursor: "pointer" }} className="my-3 text-dark">
                {user.username}
            </p>
          </OverlayTrigger>
      </Link>
  );
